export default __webpack_public_path__ + "static/media/bn.f421a4dd.svg";